import { Link } from "react-router-dom";
import { ui } from "../lib/ui";

export default function About() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-14">
      <h1 className="font-serif text-4xl sm:text-5xl font-bold text-[#8B1A1A] leading-tight">About Report Your TEF</h1>
      <div className="mt-8 space-y-6 text-[#210201] leading-relaxed text-base">
        <p>
          <strong>Report Your TEF</strong> is a community resource created by{" "}
          <a href="https://elitetefprep.com" target="_blank" rel="noopener noreferrer" className="text-[#8B1A1A] underline">Élite TEF Prep</a>,
          where TEF Canada candidates share what they saw on exam day so future test takers can prepare with confidence.
        </p>
        <p>
          After the exam, candidates report the speaking topics (Expression orale, Sections A and B), the writing prompts
          (Expression écrite, Sections A and B), and how many comprehension questions (Compréhension orale and écrite)
          matched the prediction plan they studied. Other students browse these reports to spot recurring themes.
        </p>
        <div className={ui.card + " p-6"}>
          <h2 className="font-serif text-xl font-semibold text-[#8B1A1A] mb-3">How moderation works</h2>
          <p className="text-sm text-[#5A4441] leading-relaxed">
            Every submission enters a moderation queue. Nothing is published until it has been reviewed. We fix typos and
            remove any names or personal details, including examiner names, before a report appears in the public archive.
            Submitter emails are never displayed publicly.
          </p>
        </div>
        <div className={ui.card + " p-6 bg-[#F3E5D8]"}>
          <h2 className="font-serif text-xl font-semibold text-[#8B1A1A] mb-3">Not official TEF content</h2>
          <p className="text-sm text-[#671813] leading-relaxed">
            This site is an independent, crowdsourced study aid. It is <strong>not</strong> affiliated with, endorsed by,
            or a source of official TEF / CCI Paris Île-de-France content. Reports reflect candidates' personal recollections
            and are shared for study purposes only.
          </p>
        </div>
        <p>
          Reports can be written in English or French. Ready to help?{" "}
          <Link to="/submit" className="text-[#8B1A1A] underline font-medium">Report your exam</Link>.
        </p>
      </div>
    </div>
  );
}
